class HeroFullHeight {
    constructor() {
        Object.defineProperty(this, "hero", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "windowWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.hero = document.querySelector('.hero-full');
        this.windowWidth = window.innerWidth;
    }
    init() {
        if (this.hero) {
            const windowHeight = window.innerHeight;
            const headerHeight = document.querySelector('.main-header')?.clientHeight ?? 0;
            // eslint-disable-next-line unicorn/prefer-ternary
            if (globalThis.matchMedia('screen and (min-width: 768px)').matches) {
                this.hero.style.height = `${windowHeight - headerHeight}px`;
            }
            else {
                this.hero.style.height = '';
            }
        }
    }
    resized() {
        if (this.hero && this.windowWidth !== window.innerWidth) {
            this.windowWidth = window.innerWidth;
            this.init();
        }
    }
}
export default new HeroFullHeight();
